import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { addLeadingZero, applyHashMarkToHexCode } from '@viome/vnxt-nucleus';
import FontStyles from '../../Layout/Utils/FontStyles';
import styles from './CountdownTimer.module.scss';

const _ = require('lodash'),
    intervalKey = {
        days: 'd',
        hours: 'h',
        minutes: 'm',
        seconds: 's',
    };

const CountdownTimer = ({ data, clockID, inline = false }) => {
    const { endingDate, color, fontSize } = data,
        timerComponents = [],
        calculateTimeLeft = (init) => {
            const difference = new Date(endingDate) - new Date();
            let timeLeft = {};

            if (difference > 0) {
                timeLeft = {
                    days: _.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: _.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: _.floor((difference / 1000 / 60) % 60),
                    seconds: init ? 0 : _.floor((difference / 1000) % 60),
                };
            }
            return timeLeft;
        },
        [timeLeft, setTimeLeft] = useState(calculateTimeLeft(true));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(timer);
    });

    Object.keys(timeLeft).forEach((interval) => {
        const timeLeftDigits = timeLeft[interval];
        if (Number.isInteger(timeLeftDigits)) {
            if (!timeLeftDigits && timeLeftDigits !== 0) {
                return;
            }

            timerComponents.push(
                <span
                    id={interval}
                    className={styles.digits}
                    key={Math.random()}
                >
                    {addLeadingZero(timeLeftDigits)}
                    <span className={styles.interval}>
                        {intervalKey[interval]}
                    </span>
                </span>,
            );
        }
    });

    return (
        <>
            {fontSize && !inline && (
                <FontStyles
                    sizes={fontSize}
                    rowID={`clock${clockID}`}
                    color={applyHashMarkToHexCode(color)}
                />
            )}
            <span
                className={classNames(
                    styles.countdown,
                    inline && styles.inline,
                    `clock${clockID}`,
                )}
                key={Math.random()}
                id={clockID}
            >
                {timerComponents.length ? timerComponents : null}
            </span>
        </>
    );
};

export default CountdownTimer;
